import { FunctionalCarouselProps } from '@vfuk/core-functional-carousel'

export const columnsLayout = { sm: 1, md: 3, lg: 4, xl: 4 }
export const carouselSlides: FunctionalCarouselProps['slidesToShow'] = { xl: 3, lg: 3, md: 2, sm: 1 }
export const carouselSlidesToScroll: FunctionalCarouselProps['slidesToScroll'] = { xl: 1, lg: 1, md: 1, sm: 1 }
